import { render, staticRenderFns } from "./LicenceSwitch.vue?vue&type=template&id=3adc54e8&"
import script from "./LicenceSwitch.vue?vue&type=script&lang=js&"
export * from "./LicenceSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports